export default __webpack_public_path__ + "static/media/lp-new-backfit-exercise-03.44fc0833.jpg";